import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetBatchActivities(id: string | undefined) {
  return useQuery(queries.stocks.getBatchActivitiesById(id || ''))
}
